import { RenameAccount } from './../model/rename-account';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { RenameYourAccountEventType } from '../rename-your-account.event.type';
import { TweenMax, Quint } from 'gsap';

@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SummaryComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() renameAccountData: RenameAccount;
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();
	private view = '[data-component="summary"]';
	public active = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen(RenameYourAccountEventType.STEPS.RENAME_ACCOUNT_WARNING, data => {

			if (data.show) {
				this.active = true;
				this.show();

				this.showStepButtons.emit(true);
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RenameYourAccountEventType.STEPS.RENAME_ACCOUNT_WARNING);
	}

	show() {
		AppEventDispatcher.dispatch(RenameYourAccountEventType.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rename-your-account/summary/summary.component.ts